import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Typography,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

function PasswordDialog({ open, onClose, onConfirm, title = 'Wachtwoord vereist', description }) {
  const [value, setValue] = useState('');
  const [error, setError]   = useState('');

  useEffect(() => {
    if (open) { setValue(''); setError(''); }
  }, [open]);

  const handleConfirm = () => {
    if (!value.trim()) { setError('Voer een wachtwoord in'); return; }
    onConfirm(value);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LockIcon fontSize="small" color="primary" />
        {title}
      </DialogTitle>
      <DialogContent>
        {description && (
          <Typography variant="body2" color="text.secondary" mb={1.5}>
            {description}
          </Typography>
        )}
        <TextField
          autoFocus
          type="password"
          label="Wachtwoord"
          value={value}
          onChange={e => { setValue(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
          fullWidth
          error={!!error}
          helperText={error}
          sx={{ mt: 0.5 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Annuleren</Button>
        <Button onClick={handleConfirm} variant="contained">Bevestigen</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PasswordDialog;
